module.exports = __webpack_public_path__ + "img/img-chart-03.258dfc5a.png";